import { render, staticRenderFns } from "./PdSkuDrawer.vue?vue&type=template&id=a5fbf6e2"
import script from "./PdSkuDrawer.vue?vue&type=script&lang=js"
export * from "./PdSkuDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports